/* eslint-disable */
// prettier-ignore
// THIS FILE IS AUTO-GENERATED BY EMU. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
export default {
  hard: '0px',
  rounded: '4px',
  soft: '8px',
  verySoft: '20px',
  circle: '100px',
}
